import { render } from "./ReputationRisk.vue?vue&type=template&id=8ec82540"
import script from "./ReputationRisk.vue?vue&type=script&lang=js"
export * from "./ReputationRisk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__